import {Popconfirm, Space, Tag, Tooltip} from "antd";
import {Button} from "../../components/actions/button";
import {PencilSvg, TrashSvg} from "../../components/Svg";
import React from "react";
import styled from "styled-components";

export function getColumns(onEdit, onDelete) {
    return [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: 50,
            // specify the condition of filtering result
            // here is that finding the name started with `value`
            sorter: (a, b) => a.id - b.id,
            defaultSortOrder: "ascend",
        },
        {
            title: "Заголовок",
            dataIndex: "title",
            key: "title",
            sorter: (a, b) => a.promocode - b.promocode,
        },
        {
            title: "Описание",
            dataIndex: "description",
            key: "description",
            sorter: (a, b) => a.description - b.description,
        },
        {
            title: "Позиция в списке",
            dataIndex: "sortWeight",
            key: "sortWeight",
            width: 100
        },
        {
            title: "Флаг активности",
            dataIndex: "isActive",
            key: "isActive",

            render: (text) => (
                <StyledTag color={text ? "rgb(56, 142, 60)" : "rgb(211, 47, 47)"}>
                    {text ? "ДА" : "НЕТ"}
                </StyledTag>
            ),
        },

        ...(onEdit || onDelete ? [{
            title: "Действие",
            key: "action",
            width: 100,
            fixed: "right",
            render: (_, record) => (
                <Space size="small">
                    {onEdit && (
                        <Tooltip placement="top" title="Редактировать" mouseLeaveDelay={0}>
                            <Button size="small" type="link" onClick={() => onEdit(record.id)}>
                                <PencilSvg />
                            </Button>
                        </Tooltip>
                    )}
                    {onDelete && (
                        <Tooltip placement="top" title="Удалить" mouseLeaveDelay={0}>
                            <Popconfirm
                                placement="left"
                                title="Действительно хотите удалить?"
                                onConfirm={() => onDelete(record.id)}
                                onCancel={() => stopPropagation}
                            >
                                <Button size="small" type="link" onClick={stopPropagation}>
                                    <TrashSvg />
                                </Button>
                            </Popconfirm>
                        </Tooltip>
                    )}
                </Space>
            ),
        }] : []),
    ]
}

const stopPropagation = (e) => {
    e?.stopPropagation()
}

const StyledTag = styled(Tag)`
  font-weight: 600;
  text-transform: uppercase;
`